"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.HEREMap = void 0;
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var cache_1 = require("./utils/cache");
var get_platform_1 = __importDefault(require("./utils/get-platform"));
exports.HEREMap = (0, react_1.forwardRef)(function (_a, ref) {
    var _b, _c;
    var children = _a.children, secure = _a.secure, onScriptLoadError = _a.onScriptLoadError, center = _a.center, hidpi = _a.hidpi, _d = _a.interactive, interactive = _d === void 0 ? true : _d, zoom = _a.zoom, lg = _a.lg, useSatellite = _a.useSatellite, trafficLayer = _a.trafficLayer, onMapAvailable = _a.onMapAvailable, disableMapSettings = _a.disableMapSettings, language = _a.language, congestion = _a.congestion, truckRestrictions = _a.truckRestrictions, incidentsLayer = _a.incidentsLayer, apiKey = _a.apiKey, animateZoom = _a.animateZoom, animateCenter = _a.animateCenter, useVectorTiles = _a.useVectorTiles;
    var uniqueIdRef = (0, react_1.useRef)((0, lodash_1.uniqueId)());
    var _e = (0, react_1.useState)(null), map = _e[0], setMap = _e[1];
    var _f = (0, react_1.useState)(null), routesGroup = _f[0], setRoutesGroup = _f[1];
    var markersGroupsRef = (0, react_1.useRef)({});
    var unmountedRef = (0, react_1.useRef)(false);
    var defaultLayersRef = (0, react_1.useRef)(null);
    var trafficOverlayLayerRef = (0, react_1.useRef)(null);
    var trafficBaseLayerRef = (0, react_1.useRef)(null);
    var truckOverlayLayerRef = (0, react_1.useRef)(null);
    var truckCongestionLayerRef = (0, react_1.useRef)(null);
    var usedMapTiles = useVectorTiles
        ? (_b = defaultLayersRef.current) === null || _b === void 0 ? void 0 : _b.vector.normal
        : (_c = defaultLayersRef.current) === null || _c === void 0 ? void 0 : _c.raster.normal;
    var screenToGeo = function (x, y) {
        return map.screenToGeo(x, y);
    };
    var zoomOnMarkers = function (animate, group) {
        if (animate === void 0) { animate = true; }
        if (group === void 0) { group = "default"; }
        if (map) {
            if (!markersGroupsRef.current[group]) {
                return;
            }
            var viewBounds = markersGroupsRef.current[group].getBoundingBox();
            if (viewBounds) {
                map.getViewModel().setLookAtData({ bounds: viewBounds }, animate);
            }
        }
    };
    var zoomOnMarkersSet = function (markersSet, animate) {
        if (animate === void 0) { animate = true; }
        var markersGroupSet = new H.map.Group();
        markersSet.map(function (m) { return markersGroupSet.addObject(m); });
        var viewBounds = markersGroupSet.getBoundingBox();
        if (viewBounds) {
            map.getViewModel().setLookAtData({ bounds: viewBounds }, animate);
        }
    };
    var addToMarkerGroup = function (marker, group) {
        if (!markersGroupsRef.current[group]) {
            markersGroupsRef.current[group] = new H.map.Group();
            map.addObject(markersGroupsRef.current[group]);
        }
        markersGroupsRef.current[group].addObject(marker);
    };
    var removeFromMarkerGroup = function (marker, group) {
        if (markersGroupsRef.current[group]) {
            markersGroupsRef.current[group].removeObject(marker);
            if (markersGroupsRef.current[group].getObjects().length === 0) {
                if (map.getObjects().length > 0) {
                    map.removeObject(markersGroupsRef.current[group]);
                }
                markersGroupsRef.current[group] = null;
            }
        }
    };
    (0, react_1.useImperativeHandle)(ref, function () {
        return {
            addToMarkerGroup: addToMarkerGroup,
            getElement: function () { return document.querySelector("#map-container-".concat(uniqueIdRef.current)); },
            getMap: function () { return map; },
            removeFromMarkerGroup: removeFromMarkerGroup,
            screenToGeo: screenToGeo,
            setCenter: function (point) {
                map.setCenter(point, animateCenter);
            },
            setZoom: function (newZoom) {
                map.setZoom(newZoom, animateZoom);
            },
            zoomOnMarkers: zoomOnMarkers,
            zoomOnMarkersSet: zoomOnMarkersSet
        };
    }, [map]);
    var getTruckLayerProvider = function (enableCongestion) {
        return {
            max: 20,
            min: 8,
            getURL: function (col, row, level) {
                return ["https://",
                    "1.base.maps.ls.hereapi.com/maptile/2.1/truckonlytile/newest/normal.day/",
                    level,
                    "/",
                    col,
                    "/",
                    row,
                    "/256/png8",
                    "?style=fleet",
                    "&apiKey=",
                    apiKey,
                    enableCongestion ? "&congestion" : "",
                    "&lg=",
                    lg,
                    "&=ppi",
                    hidpi ? "320" : "72",
                ].join("");
            }
        };
    };
    var getTrafficOverlayProvider = function () {
        return {
            getURL: function (col, row, level) {
                return ["https://",
                    "1.traffic.maps.ls.hereapi.com/maptile/2.1/flowtile/newest/normal.day/",
                    level,
                    "/",
                    col,
                    "/",
                    row,
                    "/256/png8",
                    "?apiKey=",
                    apiKey,
                    "&=ppi",
                    hidpi ? "320" : "72",
                ].join("");
            }
        };
    };
    var getTrafficBaseProvider = function () {
        return {
            getURL: function (col, row, level) {
                return ["https://",
                    "1.traffic.maps.ls.hereapi.com/maptile/2.1/traffictile/newest/normal.day/",
                    level,
                    "/",
                    col,
                    "/",
                    row,
                    "/256/png8",
                    "?apiKey=",
                    apiKey,
                    "&=ppi",
                    hidpi ? "320" : "72",
                ].join("");
            }
        };
    };
    (0, react_1.useEffect)(function () {
        (0, cache_1.loadScripts)(secure, !useVectorTiles).then(function () {
            if (unmountedRef.current) {
                return;
            }
            // get the platform to base the maps on
            var platform = (0, get_platform_1["default"])({
                apikey: apiKey,
                useHTTPS: secure === true
            });
            defaultLayersRef.current = platform.createDefaultLayers({
                lg: lg,
                ppi: hidpi ? 320 : 72
            });
            var truckOverlayProvider = new H.map.provider.ImageTileProvider(getTruckLayerProvider(false));
            var truckOverlayCongestionProvider = new H.map.provider.ImageTileProvider(getTruckLayerProvider(true));
            var trafficOverlayProvider = new H.map.provider.ImageTileProvider(getTrafficOverlayProvider());
            var trafficBaseProvider = new H.map.provider.ImageTileProvider(getTrafficBaseProvider());
            truckOverlayLayerRef.current = new H.map.layer.TileLayer(truckOverlayProvider);
            truckCongestionLayerRef.current = new H.map.layer.TileLayer(truckOverlayCongestionProvider);
            trafficOverlayLayerRef.current = new H.map.layer.TileLayer(trafficOverlayProvider);
            trafficBaseLayerRef.current = new H.map.layer.TileLayer(trafficBaseProvider);
            var hereMapEl = document.querySelector("#map-container-".concat(uniqueIdRef.current));
            var baseLayer = useVectorTiles
                ? defaultLayersRef.current.vector.normal.map
                : defaultLayersRef.current.raster.normal.map;
            var newMap = new H.Map(hereMapEl, baseLayer, {
                center: center,
                // @ts-ignore
                engineType: useVectorTiles ? undefined : H.map.render.RenderEngine.EngineType.P2D,
                pixelRatio: hidpi ? 2 : 1,
                zoom: zoom
            });
            var routesProvider = new H.map.provider.LocalObjectProvider();
            var routesLayer = new H.map.layer.ObjectLayer(routesProvider);
            newMap.addLayer(routesLayer);
            var ui;
            // make the map interactive
            // MapEvents enables the event system
            // Behavior implements default interactions for pan/zoom
            var behavior = interactive ? new H.mapevents.Behavior(new H.mapevents.MapEvents(newMap)) : undefined;
            if (behavior) {
                // @ts-ignore
                behavior.disable(H.mapevents.Behavior.Feature.FRACTIONAL_ZOOM);
                // create the default UI for the map
                ui = H.ui.UI.createDefault(newMap, defaultLayersRef.current, language);
                if (disableMapSettings) {
                    ui.removeControl("mapsettings");
                }
            }
            setMap(newMap);
            setRoutesGroup(routesProvider.getRootGroup());
            onMapAvailable({
                behavior: behavior,
                map: newMap,
                markersGroups: markersGroupsRef.current,
                routesGroup: routesProvider.getRootGroup(),
                trafficLayer: trafficLayer,
                ui: ui
            });
        })["catch"](onScriptLoadError);
        return function () {
            unmountedRef.current = true;
            map === null || map === void 0 ? void 0 : map.dispose();
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (map) {
            var satelliteBaseLayer = defaultLayersRef.current.raster.satellite.map;
            var emptyBaseLayer = usedMapTiles.map;
            var baseLayer = useSatellite
                ? satelliteBaseLayer
                : (trafficLayer && !useVectorTiles)
                    ? trafficBaseLayerRef.current
                    : emptyBaseLayer;
            map.setBaseLayer(baseLayer);
        }
    }, [map, useSatellite, usedMapTiles, trafficLayer]);
    (0, react_1.useEffect)(function () {
        if (map) {
            if (truckRestrictions) {
                if (congestion) {
                    map.removeLayer(truckOverlayLayerRef.current);
                    map.addLayer(truckCongestionLayerRef.current);
                }
                else {
                    map.removeLayer(truckCongestionLayerRef.current);
                    map.addLayer(truckOverlayLayerRef.current);
                }
            }
            else {
                map.removeLayer(truckCongestionLayerRef.current);
                map.removeLayer(truckOverlayLayerRef.current);
            }
        }
    }, [truckRestrictions, congestion, map]);
    (0, react_1.useEffect)(function () {
        if (map) {
            if (incidentsLayer) {
                map.addLayer(usedMapTiles.trafficincidents);
            }
            else {
                map.removeLayer(usedMapTiles.trafficincidents);
            }
        }
    }, [incidentsLayer, map, usedMapTiles]);
    (0, react_1.useEffect)(function () {
        if (map) {
            if (trafficLayer) {
                if (useVectorTiles) {
                    // Adding the vector traffic layer is not strictly necessary,
                    // however it's helpful because it changes the color for roads
                    // and highways to white which makes the traffic data more visible.
                    map.addLayer(defaultLayersRef.current.vector.normal.traffic);
                }
                // Ideally, we wouldn't need to add an additional layer here and
                // the vector traffic layer added above would be enough, however
                // the vector traffic layer is only visible on a high zoom level,
                // and if the zoom level is changed using setMin, then performance
                // issues appear.
                map.addLayer(trafficOverlayLayerRef.current);
            }
            else {
                map.removeLayer(defaultLayersRef.current.vector.normal.traffic);
                map.removeLayer(trafficOverlayLayerRef.current);
            }
        }
    }, [trafficLayer, map]);
    (0, react_1.useEffect)(function () {
        if (map) {
            var resizeMap = function () {
                map.getViewPort().resize();
            };
            var debouncedResizeMap_1 = (0, lodash_1.debounce)(resizeMap, 200);
            // make the map resize when the window gets resized
            window.addEventListener("resize", debouncedResizeMap_1);
            return function () {
                window.removeEventListener("resize", debouncedResizeMap_1);
            };
        }
    }, [map]);
    return (react_1["default"].createElement("div", { className: "heremap", style: { height: "100%" } },
        react_1["default"].createElement("div", { className: "map-container", id: "map-container-".concat(uniqueIdRef.current), style: { height: "100%" } }, map && react_1["default"].createElement(context_1.HEREMapContext.Provider, { value: { map: map, routesGroup: routesGroup, removeFromMarkerGroup: removeFromMarkerGroup, addToMarkerGroup: addToMarkerGroup } }, children))));
});
// make the HEREMap component the default export
exports["default"] = exports.HEREMap;
